import React from "react";
import { Modal, Progress } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const SyncBlockingModal = ({ open, message, progress = null, pendingCount = null }) => {
  const hasProgress = typeof progress === "number" && Number.isFinite(progress);

  return (
    <Modal open={open} closable={false} maskClosable={false} keyboard={false} footer={null} centered>
      <div style={{ marginBottom: 8 }}>{message || "A sincronizar..."}</div>
      {hasProgress ? (
        <Progress percent={progress} status="active" />
      ) : (
        <div className="d-flex align-items-center">
          <LoadingOutlined spin style={{ fontSize: 22 }} className="mr-2" />
          <span>A sincronizar...</span>
        </div>
      )}
      {typeof pendingCount === "number" && <div style={{ marginTop: 8, color: "#8c8c8c" }}>{pendingCount} ações pendentes na fila</div>}
    </Modal>
  );
};

export default SyncBlockingModal;
